import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import SupplierPartsTab from '../maintenances/SupplierPartsTab';
import HelpButton from '../shared/HelpButton';

/**
 * "Tuo ostoskori" for a lähete: the same vendor punch-out + basket import as the
 * work order's Varaosatoimittajat tab, landing every product as a to_order
 * special-order line (ordered from Verstaani afterwards, from the lähete's own
 * banner or Varaosatilaukset → Odottavat).
 */
function LaheteCartImportDialog({ open, onClose, sale, onImported }) {
  const { t } = useTranslation();
  const [hideFromRegistry, setHideFromRegistry] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
      <DialogTitle sx={{ pb: 0.5 }}>{t('parts_sales.importCartTitle')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {t('parts_sales.importCartHint')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={hideFromRegistry}
                onChange={(e) => setHideFromRegistry(e.target.checked)}
                data-testid="lahete-cart-hide-from-registry"
              />
            }
            label={<Typography variant="body2">{t('Hide from parts registry')}</Typography>}
          />
          <HelpButton text={t('hideFromRegistryHelp')} />
        </Box>
        {error && (
          <Alert severity="error" sx={{ mb: 1.5 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}
        {open && (
          <SupplierPartsTab
            partsSale={sale}
            hideFromRegistry={hideFromRegistry}
            onImported={(count) => {
              setError(null);
              onImported(count);
            }}
            onError={setError}
            handleClose={handleClose}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('Close')}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default LaheteCartImportDialog;
